// @flow
import React, { Component } from 'react';
import styled from 'styled-components';
import { ArrowRight } from '@e4/ui/src/components/svg';
import { Link } from './Link';
import type { LocationShape } from 'react-router-dom';

const StyledLink = styled(Link)`
  text-decoration: none;
  &:hover {
    color: ${(props) =>
      props.disabled ? props.theme.disabledColor : props.theme.actionColor};
  }
`;

const StyledArrowRight = styled(ArrowRight)`
  opacity: 0;
  ${StyledLink}:hover & {
    color: ${(props) => props.theme.actionColor};
    opacity: 1;
    transform: translateX(0.3em);
    transition: all 0.2s linear;
  }
`;

type targetType = '_blank' | '_self' | '_parent' | '_top';

type Props = {
  id: string,
  text: string,
  to: string | LocationShape,
  disabled?: boolean,
  className?: string,
  target?: targetType,
};

export class ArrowLink extends Component<Props> {
  render() {
    const { id, text, to, disabled, className, target } = this.props;
    return (
      <StyledLink
        target={target}
        id={id}
        to={to}
        disabled={disabled}
        className={className}
      >
        {text}
        {disabled ? null : (
          <StyledArrowRight height={'0.9em'} width={'0.9em'} />
        )}
      </StyledLink>
    );
  }
}

export default ArrowLink;
